import { api, setConfig, ENABLE_USER_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const activateAccount = (data: PropertyType): Promise<string | void> =>
	api.post('/user/enable', mapEntityToApi(data), setConfig(data)).then(() => {
		return ENABLE_USER_MESSAGE;
	});
